import { API_STATES } from '@/helpers'

const state = {
  emailTemplatesGetState : API_STATES.NOT_REQUESTED,
  emailTemplatesGetError : null,
  emailTemplates         : [],
}

export default state